import React, { useState } from 'react';
import {
    useInterval,
    getSessionDuration,
    getPercentOfTimeElapsed,
    isSessionDurationOver,
    getTimeFromSessionStart,
    getSessionDurationInMs,
} from './sessionBroadcastUtils';

const SessionTimePassed = ({ startDate, startMinute, endDate, endMinute, eventTimeZone, pace = 1000 }) => {
    const dates = {
        startDate,
        startMinute,
        endDate,
        endMinute,
        eventTimeZone
    };
    const [progressBarWidth, setProgress] = useState(() => getPercentOfTimeElapsed(dates));
    const [timeFromSessionStart, setTimeFromSessionStart] = useState('00:00:00');
    const durationFormatted = getSessionDuration({ ...dates });
    const durationInMilliseconds = getSessionDurationInMs({ ...dates });
    const progressBarStep = 100 / (durationInMilliseconds / pace);
    const isSessionOver = isSessionDurationOver(dates);

    useInterval(() => {
        if (isSessionOver) {
            setTimeFromSessionStart(durationFormatted);
        } else {
            const updatedTimeFromSessionStart = getTimeFromSessionStart({startDate, startMinute, eventTimeZone});
            setTimeFromSessionStart(updatedTimeFromSessionStart);
            setProgress(progressBarWidth => progressBarWidth + progressBarStep);
        }
    }, isSessionOver ? null : pace);

    return (
        <div className="time-passed">
            {!isSessionOver &&
            <span className='live-label'>
                <span className='circle-live-now not-blinking'/> LIVE
            </span>
            }
            <div className="time-passed-inner">
                <div className="time-passed-value">{timeFromSessionStart} / <span className="time-passed-title">{durationFormatted}</span></div>
            </div>
            <div className="progress-entire">
                <div
                    key={progressBarWidth}
                    className="progress-done custom-color color-1-background"
                    style={{ width: `${progressBarWidth}%` }}
                />
            </div>
        </div>
    );
};

export default SessionTimePassed;
